module.exports = __webpack_public_path__ + "img/go_to_class_btn_background.ba481fc2.png";